import * as $ from 'jquery';
import AppSingleton from '../../services/appSingleton';
import App from '../app';

export default class Slideshow {

    private jqueryElement:any;
    private slideshowMask:any;
    private numberPerPage:number;
    private numberTotalElements:number;
    private numberPages:number;
    private currentPage:number;
    private elementContainer:any;
    private sliderDots:any;
    private arrowLeft:any;
    private arrowRight:any;
    private autoplayInterval:any;
    private elements:any;
    private config:any;
    private containerWidth:number;
    private maskWidth:number;
    private autoplayDelay:number;
    private arrowContainer:any;
    private app:App;

    /**
     * Constructor
     *
     * @param jqueryElement
     * @param numberElementsPerScreen
     */
    constructor(jqueryElement:any, numberElementsPerScreen:number) {
        this.app = AppSingleton.getInstance();
        this.numberPerPage = numberElementsPerScreen;
        this.jqueryElement = jqueryElement;
        this.elements = this.jqueryElement.children();
        this.numberTotalElements = this.jqueryElement.children().length;
        this.autoplayInterval = null;
        this.config = this.jqueryElement.data('config') ? this.jqueryElement.data('config') : {};
        this.autoplayDelay = 'autoplayDelay' in this.config ? this.config.autoplayDelay : 5000;

        this.init();
    }

    init() {
        this.calculateContainerWidth();
        this.calculateNumberPages();
        this.buildHtml();
        this.goToPage(0);
        //this.bindAutoplayEvent();

        if (this.app.isMobile()) {
            this.lazyLoadImagesOnMobile();
        }

        $(window).on('resize', () => {
            if (this.app.isMobile()) {
                this.lazyLoadImagesOnMobile();
            }
        });
    }

    calculateNumberPages() {
        this.numberPages = Math.ceil(this.numberTotalElements / this.numberPerPage);
    }

    /**
     * Lazy load images of a given page
     *
     * @param page
     */
    lazyLoadImages(page:number) {
        const img = this.getPageElements(page).map(elem => $(elem).find('img'));

        img.forEach((imgElement) => {
            imgElement.attr('src', imgElement.attr('data-src'));
        });
    }

    /**
     *
     */
    lazyLoadImagesOnMobile() {
        const img = this.jqueryElement.find('img');

        img.each((index, imgElement) => {
            $(imgElement).attr('src', $(imgElement).attr('data-src'));
        });
    }

    /**
     * Get all jquery objects in the given page
     *
     * @param page
     * @returns {any}
     */
    getPageElements(page:number) {
        let returnImages = [];

        if (page >= 0 && page < this.numberPages) {
            const elements = this.elementContainer.children();

            elements.each((index, element) => {
                if (index >= page * this.numberPerPage && index < page * this.numberPerPage + this.numberPerPage) {
                    returnImages.push(element);
                }
            });
        }

        return returnImages;
    }

    /**
     * Build the html
     */
    buildHtml() {
        // Slideshow container
        this.elementContainer = $('<div>').addClass('slideshow-container').append(this.jqueryElement.children())
            .css('width', this.containerWidth);
        this.slideshowMask = $('<div>').addClass('slideshow-mask')
            .append(this.elementContainer).css('width', this.maskWidth);
        this.jqueryElement.html(this.slideshowMask);

        // Slider dots
        this.sliderDots = $('<div>').addClass('slider-dots').appendTo(this.jqueryElement);
        this.calculateDots();

        // Slider arrows
        this.arrowContainer = $('<div>').addClass('slideshow-arrow-container').prependTo(this.jqueryElement)
            .css('width', this.maskWidth);
        this.arrowLeft = $('<div>').addClass('slideshow-arrow left').appendTo(this.arrowContainer).click(() => {
            this.goToPage(this.getPrevPage());
        });
        this.arrowRight = $('<div>').addClass('slideshow-arrow right').appendTo(this.arrowContainer).click(() => {
            this.goToPage(this.getNextPage());
        });

        if ('arrowsColor' in this.config) {
            this.arrowLeft.css('color', this.config.arrowsColor);
            this.arrowRight.css('color', this.config.arrowsColor);
        }

        this.showHideArrows();
        this.jqueryElement.addClass('initialized');
    }

    /**
     * Calculate the size of the slideshow container
     */
    calculateContainerWidth() {
        this.containerWidth = 0;
        const firstElement = this.elements.first();

        if (firstElement) {
            const widthElement = firstElement.outerWidth();
            const marginElement = parseInt(firstElement.css('marginRight'));
            this.maskWidth = ((widthElement + marginElement) * this.numberPerPage) - marginElement;
            this.containerWidth = ((widthElement + marginElement) * this.numberPerPage);
        }
    }

    /**
     * Build dots
     */
    calculateDots() {
        this.sliderDots.html('');

        for (let i = 0; i < this.numberPages; i++) {
            $('<div>').addClass('slider-dot').click(element => this.goToPage(i)).appendTo(this.sliderDots);
        }
    }

    getPrevPage() {
        return this.currentPage - 1 >= 0 ? this.currentPage - 1 : this.numberPages - 1;
    }

    getNextPage() {
        return this.currentPage + 1 < this.numberPages ? this.currentPage + 1 : 0;
    }

    showHideArrows() {

        if (this.numberPages <= 1) {
            this.arrowLeft.addClass('hidden');
            this.arrowRight.addClass('hidden');
        } else {
            this.arrowLeft.removeClass('hidden');
            this.arrowRight.removeClass('hidden');
        }
    }

    /**
     * Set the active dot
     *
     * @param page
     */
    setActiveDot(page) {
        const dots = this.sliderDots.children();

        dots.removeClass('active');
        dots.each((index:number, element) => {
            if (index === page) {
                $(element).addClass('active');
            }
        });
    }

    /**
     * @param page
     */
    goToPage(page:number) {
        if (page >= 0 && page < this.numberPages) {
            this.currentPage = page;

            // lazy load page images
            this.lazyLoadImages(this.currentPage);

            // Set the active dot
            this.setActiveDot(page);

            // Set the position of container
            this.elementContainer.css('transform', 'translateX(' + this.calculatePosition(page) + 'px)');

            // Rebind Autoplay event
            //this.bindAutoplayEvent();
        }
    }

    /**
     * @param page
     * @returns {number}
     */
    calculatePosition(page:number) {
        return -(page * this.elementContainer.width());
    }

    /**
     * Bind Events like automatic scroll
     */
    bindAutoplayEvent() {
        this.clearAutoplayEvent();

        if (this.numberPages > 1) {
            this.autoplayInterval = setInterval(() => {
                if (!this.jqueryElement.is(':hover')) {
                    this.goToPage(this.getNextPage());
                }
            }, this.autoplayDelay);
        }
    }

    /**
     * Add an element to the html
     *
     * @param html
     */
    addElement(html) {
        this.elements.push($(html).appendTo(this.elementContainer));
        this.reset();
    }

    /**
     * Reset Slideshow
     */
    reset() {
        this.numberTotalElements = this.elements.length;
        this.calculateNumberPages();
        this.showHideArrows();
        this.calculateDots();
        this.goToPage(0);
        this.lazyLoadImagesOnMobile();
    }

    /**
     * Destroy the slideshow
     */
    destroy() {
        this.jqueryElement.html(this.elementContainer.html()).removeClass('initialized');
        this.clearAutoplayEvent();
    }

    clearAutoplayEvent() {
        if (this.autoplayInterval != null) {
            clearInterval(this.autoplayInterval);
        }
    }

    /**
     * Rebuild
     */
    rebuild() {
        this.destroy();
        this.constructor(this.jqueryElement, this.numberPerPage);
    }

    /**
     * Empty Slideshow
     */
    emptySlideshow() {
        this.elements = [];
        this.elementContainer.html('');
        this.reset();
    }
}